// ETA is stored app-wide as a zero-padded "DD/MM/YYYY" string (see the
// list view's ProdaffTasksTab.component.jsx), but SingleDatePicker
// consumes/emits plain "YYYY-MM-DD" strings — these convert at that
// boundary so the stored format never changes.
export const etaToPickerDate = (eta) => {
  if (!eta) return null;
  const [day, month, year] = eta.split('/');
  if (!day || !month || !year) return null;
  return `${year}-${month}-${day}`;
};

export const pickerDateToEta = (pickerDate) => {
  if (!pickerDate) return null;
  const [year, month, day] = pickerDate.split('-');
  if (!day || !month || !year) return null;
  return `${day}/${month}/${year}`;
};

export const formatRelativeTime = (timestamp) => {
  const date = new Date(timestamp);
  const diffMs = Date.now() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
};
